import type { SVGProps } from 'react'
const SvgSyTrash = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M4 7.5c0-.236 0-.354.073-.427S4.264 7 4.5 7h15c.236 0 .354 0 .427.073S20 7.264 20 7.5v.252c0 .09 0 .136-.014.176a.25.25 0 0 1-.057.092c-.03.03-.07.05-.151.091-.651.325-.976.488-1.213.732a2 2 0 0 0-.453.733C18 9.896 18 10.26 18 10.988V16c0 1.886 0 2.828-.586 3.414S15.886 20 14 20h-4c-1.886 0-2.828 0-3.414-.586S6 17.886 6 16v-5.012c0-.728 0-1.092-.112-1.412a2 2 0 0 0-.453-.733c-.237-.244-.562-.407-1.213-.732a.6.6 0 0 1-.151-.091.25.25 0 0 1-.057-.092C4 7.888 4 7.842 4 7.752z"
		/>
		<path d="M12 3.5a7 7 0 0 0-1.312.111c-.391.075-.687.139-.961.395a.5.5 0 0 0-.024.705.5.5 0 0 0 .705.025c-.046.044.161-.083.469-.142.308-.06.71-.094 1.123-.094s.815.035 1.123.094.515.186.469.142a.5.5 0 0 0 .705-.025.5.5 0 0 0-.024-.705c-.274-.256-.57-.32-.96-.395A7 7 0 0 0 12 3.5" />
		<rect width={1} height={6} x={14} y={11} rx={0.5} />
		<rect width={1} height={6} x={9} y={11} rx={0.5} />
	</svg>
)
export default SvgSyTrash
